module.exports = __webpack_public_path__ + "static/img/msyst-web-bg.fcc7ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/msyst-web-bg.jpg
// module id = YgCR
// module chunks = 1